import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PageContainer } from "../../../components/core/basic/PageContainer";
import { Tab, TabList, TabPanel, Tabs } from "react-aria-components";
import Card from "../../../components/core/basic/Card";
import { FaShield, FaUser, FaUsers } from "react-icons/fa6";
import { VStack } from "../../../../styled-system/jsx";
import { css } from "../../../../styled-system/css";
import OrgSettingsSection from "../../../modules/settings/tabs/OrgSettingsSection";
import ProfileSettingsSection from "../../../modules/settings/tabs/ProfileSettingsSection";
import SecuritySettingsSection from "../../../modules/settings/tabs/SecuritySettingsSection";

const Settings = () => {
  const { t } = useTranslation(["settings"]);
  const [selectedTab, setSelectedTab] = useState("profile");

  const TABS = [
    {
      id: "profile",
      label: t(($) => $.settings["Profile"]),
      icon: FaUser,
      content: <ProfileSettingsSection />,
    },
    {
      id: "security",
      label: t(($) => $.settings["Security"]),
      icon: FaShield,
      content: <SecuritySettingsSection />,
    },
    {
      id: "organization",
      label: t(($) => $.settings["Organization"]),
      icon: FaUsers,
      content: <OrgSettingsSection />,
    },
  ];

  return (
    <PageContainer>
      <VStack
        gap="medium"
        alignItems={"stretch"}
        alignSelf={"center"}
        width={"100%"}
        maxWidth={"1200px"}
        paddingY="large"
        paddingX={{ base: "medium", md: "xxlarge" }}
      >
        <h1 className={css({ fontSize: "xxlarge", fontWeight: "bold", textAlign: "center" })}>
          {t(($) => $.settings["Manage Your Settings"])}
        </h1>
        <Card>
          <Tabs
            orientation="vertical"
            className={css({ display: "flex", gap: "large" })}
            onSelectionChange={(key) => {
              setSelectedTab(String(key));
            }}
          >
            <VStack
              gap="0"
              alignItems="stretch"
              className={css({
                borderRight: "1px solid lightgray",
                width: "200px",
                paddingX: "medium",
                fontSize: "large",
              })}
            >
              <TabList
                aria-label={t(($) => $.settings["User settings tabs"])}
                className={css({
                  display: "flex",
                  gap: "medium",
                  flexDirection: "column",
                })}
              >
                {TABS.map((tab) => {
                  const Icon = tab.icon;

                  return (
                    <Tab
                      key={tab.id}
                      id={tab.id}
                      className={css({
                        cursor: "pointer",
                        display: "flex",
                        gap: "small",
                        alignItems: "center",
                        textDecoration: selectedTab === tab.id ? "underline" : "none",
                      })}
                    >
                      <Icon /> {tab.label}
                    </Tab>
                  );
                })}
              </TabList>
            </VStack>

            {TABS.map((tab) => (
              <TabPanel key={tab.id} id={tab.id} className={css({ width: "100%" })}>
                {tab.content}
              </TabPanel>
            ))}
          </Tabs>
        </Card>
      </VStack>
    </PageContainer>
  );
};

export const Route = createFileRoute("/_authenticated/user/settings")({
  component: Settings,
  staticData: { application: "Admin" },
});
